<template>
    <div class="schedule_meeting">
        <div class="meeting_header">
            <div class="header_left">
                <el-popover placement="bottom-end" v-model="visible" width="400">
                    <div class="header_left_popover">
                        <el-calendar :value="activeIndexDay" @change="handleDateChangeS">
                            <template slot="dateCell" slot-scope="{date, data}">
                                <div class="popover_item_hover" style="width: 100%;height: 40px; display: flex; justify-content: center;
                                align-items: center;
                                " :style="data.isSelected ? 'background: #409EFF;color: #fff;' : ''"
                                    @click="handleDateChange(data)"
                                    v-if="dayjs(date).isBefore(query.end) || dayjs(dayjs(date).format('YYYY-MM-DD')).isSame(query.end)">
                                    {{ dayjs(date).format("DD") }}
                                </div>
                                <div style="width: 100%;height: 40px; display: flex; justify-content: center;
                                align-items: center;
                                color: rgba(0, 0, 0, 0.4)
                                " @click.stop v-else>
                                    {{ dayjs(date).format("DD") }}
                                </div>
                            </template>
                        </el-calendar>
                    </div>
                    <div class="header_left_btn" slot="reference">
                        <i class="el-icon-date"></i>
                    </div>
                </el-popover>
            </div>
            <div class="header_right_warp" ref="scorll_box">
                <div class="header_right">
                    <div class="header_right_item" :class="activeIndexDay == item.day ? 'header_right_item_active' : ''"
                        v-for="( item, index ) in dayList " @click="onActiveItem(item, index)" :key="index">
                        <div class="right_item_top">
                            {{ item.weekDay }}
                        </div>
                        <div class="right_item_bottom"
                            :class="activeIndexDay == item.day ? 'right_item_bottom_active' : ''">
                            {{ dayjs(item.day).format("MM/DD") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="display: flex;margin: 10px 0;">
            <div class="add_meeting" style="margin-right: 20px;">
                <Button type="info" @click="onAddMeeting()"> 预定会议 </Button>
            </div>
            <div class="add_meeting" style="margin-right: 20px;">
                <Button type="info" @click="onAddMeetingRoom()"> 新增会议室 </Button>
            </div>
            <div style="width: 100%; font-weight: 800; font-size: 18px;color: red;margin-bottom: 5px;">创建会议时请预留足够的签到时间
            </div>
        </div>
        <div class="meeting_main">
            <div class="meeting_main_theader">
                <div class="theader_boxhead theader_boxhead_title">
                    会议室<span style="font-size: 14px;">（{{ dateTime[0] }}~{{ dateTime[dateTime.length - 1] }}）</span>
                </div>
                <div class="theader_boxhead" v-for=" item in dateTime.slice(0, dateTime.length - 1) " :key="item">
                    {{ item }}
                </div>
            </div>
            <div class="meeting_main_tmain_box" v-for="(timeSlot, rowIndex) in meetingList" :key="timeSlot.id">
                <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">
                        <div style="font-size: 14px; line-height: 25px;">
                            <div>会议室名称：{{ timeSlot.meetingName }}</div>
                            <div>会议室地址：{{ timeSlot.address }}</div>
                            <div>会议室创建人：{{ timeSlot.createBy }}</div>
                            <div v-show="timeSlot.liablePersonName">会议室审核人：{{ timeSlot.liablePersonName }}</div>
                        </div>
                    </div>
                    <div class="theader_boxhead theader_boxhead_title">
                        {{ timeSlot.meetingName }}{{ timeSlot.liableState == 1 ? "（需要审核）" : "" }}
                    </div>
                </el-tooltip>

                <template v-if="timeSlot.meetingList">
                    <div class="theader_boxhead_item_box" :key="meetingItem"
                        :class="{ selected: isSelected(rowIndex, index) }" v-for="meetingItem in timeSlot.meetingList"
                        :style="{
                            position: 'absolute',
                            left: `calc(${onLeftIndex(meetingItem, 'left')} * ((100% - 278px) / 60)  + 279px)`,
                            width: `calc((100% - 278px) / 60 * ${onLeftIndex(meetingItem, 'width')} + 1px)`,
                            borderRight: '1px solid #fff',
                            boxSizing: 'border-box',
                        }">
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content">
                                <div style="font-size: 16px;padding: 10px;text-align: center;">
                                    <div>{{ meetingItem.principalName }}创建的{{ meetingItem.meetingtTitle }}</div>
                                    <div>{{ dayjs(meetingItem.meetingStateTime).format("HH:mm") }} - {{
                                        dayjs(meetingItem.meetingEndTime).format("HH:mm") }}</div>
                                </div>
                            </div>
                            <div style="width: 100%;height: 50px;" @click="onDetails(meetingItem)">{{
                                meetingItem.principalName }}</div>
                        </el-tooltip>
                    </div>
                </template>
                <div class="meeting_main_tmain" @mousedown="startSelection(rowIndex, $event)" @mouseup="endSelection"
                    @mouseleave="endSelection" @mousemove="selectSlots">
                    <div class="theader_boxhead_item" @click="singleSelect(rowIndex, index)"
                        v-for="(item, index) in dateTimeList" :key="item"
                        :class="{ selected: isSelected(rowIndex, index), disabledClass: isDisabledClass(item) }">
                    </div>
                </div>

            </div>

            <!-- <div v-if="selectedTime" class="selected-time">
                选中的时间: {{ selectedTime }}
            </div> -->
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import AddMeeting from "./operate/addMeeting1.vue";
import SignIn from "./operate/signIn.vue";
import AddMeetingRoom from './operate/addMeetingRoom.vue';
export default {
    data() {
        return {
            dayList: [],
            dayjs: dayjs,
            activeIndexDay: "",
            activeItem: {},
            start: null,
            end: null,
            selecting: false,
            selectedTime: '',
            query: {
                begin: "",
                end: ""
            },
            dateTime: [
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
                "12:00",
                "13:00",
                "14:00",
                "15:00",
                "16:00",
                "17:00",
                "18:00",
                "19:00",
                "20:00",
                "21:00",
                "22:00",
            ],
            dateTimeList: [
                { time: "07:15", is: false },
                { time: "07:30", is: false },
                { time: "07:45", is: false },
                { time: "08:00", is: false },
                { time: "08:15", is: false },
                { time: "08:30", is: false },
                { time: "08:45", is: false },
                { time: "09:00", is: false },
                { time: "09:15", is: false },
                { time: "09:30", is: false },
                { time: "09:45", is: false },
                { time: "10:00", is: false },
                { time: "10:15", is: false },
                { time: "10:30", is: false },
                { time: "10:45", is: false },
                { time: "11:00", is: false },
                { time: "11:15", is: false },
                { time: "11:30", is: false },
                { time: "11:45", is: false },
                { time: "12:00", is: false },
                { time: "12:15", is: false },
                { time: "12:30", is: false },
                { time: "12:45", is: false },
                { time: "13:00", is: false },
                { time: "13:15", is: false },
                { time: "13:30", is: false },
                { time: "13:45", is: false },
                { time: "14:00", is: false },
                { time: "14:15", is: false },
                { time: "14:30", is: false },
                { time: "14:45", is: false },
                { time: "15:00", is: false },
                { time: "15:15", is: false },
                { time: "15:30", is: false },
                { time: "15:45", is: false },
                { time: "16:00", is: false },
                { time: "16:15", is: false },
                { time: "16:30", is: false },
                { time: "16:45", is: false },
                { time: "17:00", is: false },
                { time: "17:15", is: false },
                { time: "17:30", is: false },
                { time: "17:45", is: false },
                { time: "18:00", is: false },
                { time: "18:15", is: false },
                { time: "18:30", is: false },
                { time: "18:45", is: false },
                { time: "19:00", is: false },
                { time: "19:15", is: false },
                { time: "19:30", is: false },
                { time: "19:45", is: false },
                { time: "20:00", is: false },
                { time: "20:15", is: false },
                { time: "20:30", is: false },
                { time: "20:45", is: false },
                { time: "21:00", is: false },
                { time: "21:15", is: false },
                { time: "21:30", is: false },
                { time: "21:45", is: false },
                { time: "22:00", is: false },

            ],
            meetingList: [],
            rowIndex: null
        };
    },
    components: { AddMeeting, SignIn, AddMeetingRoom },
    created() {
        this.query.begin = dayjs().format("YYYY-MM-DD")
        this.query.end = dayjs().add(1, 'year').format("YYYY-MM-DD")
        this.activeIndexDay = dayjs().format('YYYY-MM-DD')
        this.getDayList()
        this.getMeetingList()
        this.$nextTick(() => {
            let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
            prevBtn.addEventListener('click', () => {
                this.activeIndexDay = dayjs(this.activeIndexDay).subtract(1, 'month').format("YYYY-MM-DD")
                this.updateDate(this.activeIndexDay)
            })
            let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
            nextBtn.addEventListener('click', () => {
                // if()
                let nextTimeDate = dayjs(this.activeIndexDay).add(1, 'month').format("YYYY-MM-DD")
                if (dayjs(nextTimeDate).isBefore(this.query.end) || dayjs(nextTimeDate).isSame(this.query.end)) {
                    this.activeIndexDay = nextTimeDate
                } else {
                    this.activeIndexDay = this.query.end
                    // console.log(nextBtn);
                    nextBtn.disabled = true;
                }
                this.updateDate(this.activeIndexDay)
            })
            let todayBtn = document.querySelector(
                ".el-calendar__button-group .el-button-group>button:nth-child(2)"
            );
            todayBtn.addEventListener("click", () => {
                this.activeIndexDay = dayjs().format("YYYY-MM-DD")
                this.updateDate(this.activeIndexDay)
            });
        })

    },
    computed: {

    },
    watch: {
        activeIndexDay(newValue, oldValue) {
            // console.log(`myValue changed from "${oldValue}" to "${newValue}"`);
            // 可以在这里执行其他逻辑
            this.restClose()
            this.$nextTick(() => {
                let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
                if (nextBtn.disabled) {
                    if (dayjs(newValue).isBefore(this.query.end) || dayjs(newValue).isSame(this.query.end)) {
                        nextBtn.disabled = false;
                    }
                }
            })
        },
        selectedTime(newValue, oldValue) {
            let newValueStr = newValue.slice(0, newValue.indexOf('='))
            if (newValueStr) {
                let item = {
                    newTime: newValueStr,
                    activeIndexDay: this.activeIndexDay,
                    meetingListItem: this.meetingList[this.rowIndex]
                }

                let beginTime = item.activeIndexDay + " " + item.newTime.split("-")[0];
                if (dayjs(beginTime).isAfter(dayjs())) {
                    this.$Modal.success({
                        closable: true,
                        width: "800px",
                        height: "80px",
                        okText: "取消",
                        showOk: false,
                        render: (h) => {
                            return (
                                <div>
                                    <AddMeeting
                                        onOnCancel={() => {
                                            this.onCancel();
                                        }}
                                        action="add"
                                        newItem={item}
                                    />
                                </div>
                            );
                        },
                    });
                } else {
                    // $utils.toast.success("当前时间无法预定！");
                    this.$Modal.success({
                        closable: true,
                        width: "800px",
                        height: "80px",
                        okText: "取消",
                        showOk: false,
                        render: (h) => {
                            return (
                                <div style="width:100%; font-size:20px;font-weight:800; text-align:center;">
                                    当前时间无法预定！
                                </div>
                            );
                        },
                    });
                    setTimeout(() => {
                        this.$Modal.remove();
                    }, 3000);
                }
            }
        },
    },
    methods: {
        onDetails(item) {
            this.toClaim(item);
        },
        onCancel() {
            this.$Modal.remove();
            this.restClose();
        },
        restClose() {
            this.getMeetingList();
            this.start = null;
            this.end = null;
            this.selectedTime = "";
            this.rowIndex = null;
            this.activeItem = {};
            this.selecting = false;
        },
        toClaim(Row) {
            $utils.api.load(`/admin/system/meeting/${Row.meetingId}`, {}).then((res) => {
                if (res && res.data) {
                    let type = res.data.type;
                    if (type == 5) {
                        $utils.toast.success("会议审核中,请稍后!");
                    } else if (type == 7) {
                        $utils.toast.success("会议已取消!");
                    } else {
                        this.$Modal.success({
                            closable: true,
                            width: "1300px",
                            height: "80px",
                            okText: "取消",
                            showOk: false,
                            render: (h) => {
                                return (
                                    <div>
                                        <SignIn
                                            onOnCancel={() => {
                                                this.onCancel();
                                            }}
                                            id={Row.meetingId}
                                        />
                                    </div>
                                );
                            },
                        });
                    }
                }
            });
            /*   this.$Modal.success({
                      closable: true,
                      width: "1300px",
                      height: "80px",
                      okText: "取消",
                      showOk: false,
                      render: (h) => {
                          return (
                              <div>
                                  <SignIn
                                      onOnCancel={() => {
                                          this.onCancel();
                                      }}
                                      id={Row.meetingId}
                                  />
                              </div>
                          );
                      },
                  }); */
        },
        onLeftIndex(item, stateA) {
            // console.log(item);
            let state = dayjs(item.meetingStateTime).format("HH:mm");
            let end = dayjs(item.meetingEndTime).format("HH:mm");
            // console.log(state, end);
            let stateIndex = null;
            let endIndex = null;
            this.dateTimeList.forEach((item, index) => {
                if (state == "07:00") {
                    stateIndex = 0;
                } else if (item.time == state) {
                    stateIndex = index + 1;
                }
                if (item.time == end) {
                    endIndex = index;
                }
            });
            // console.log(stateIndex, endIndex);
            if (stateA == "left") {
                // console.log(stateIndex, 111);
                return stateIndex;
            }
            if (stateA == "width") {
                // console.log((endIndex + 1) - (stateIndex - 1), 111112);

                return endIndex - (stateIndex - 1);
            }
        },
        getMeetingList() {
            let q = {
                begin: this.activeIndexDay + " 00:00:00",
                end: this.activeIndexDay + " 23:59:59",
            };
            $utils.api.load("/admin/system/meeting/room/selectList", q, "get").then((res) => {
                // console.log(res);
                if (res.code == 200) {
                    this.meetingList = res.rows;
                }
            });
        },
        startSelection(rowIndex, event) {
            this.rowIndex = rowIndex;
            const index = this.getSlotIndex(event);

            if (index !== null) {
                this.start = index;
                this.end = index;
                this.selecting = true;
            }
        },
        singleSelect(rowIndex, index) {
            this.rowIndex = rowIndex;
            this.start = index;
            this.end = index;
            this.updateSelectedTime();
        },
        endSelection() {
            this.selecting = false;
            this.updateSelectedTime();
        },
        selectSlots(event) {
            // console.log(event);

            if (this.selecting) {
                const index = this.getSlotIndex(event);
                if (index !== null) {
                    this.end = index;
                }
            }
        },
        getSlotIndex(event) {
            if (event) {
                const target = event.target;
                const slotIndex = Array.from(target.parentElement.children).indexOf(target);
                return slotIndex >= 0 ? slotIndex : null;
            }
        },
        isSelected(rowIndex, index) {
            if (this.start === null || this.end === null || rowIndex != this.rowIndex) return false;
            return (index >= Math.min(this.start, this.end) && index <= Math.max(this.start, this.end));
        },
        isDisabledClass(item) {
            let thisTime = dayjs(this.activeIndexDay + " " + item.time).subtract(15, 'minute')
            return dayjs(thisTime).isBefore(dayjs()) // 默认毫秒 ? true : false

        },
        updateSelectedTime() {
            if (this.start !== null && this.end !== null) {

                if (this.end >= this.start) {
                    let startTime = ""
                    if (this.start == 0) {
                        startTime = "07:00";
                    } else {
                        startTime = this.dateTimeList[this.start - 1].time;
                    }

                    const endTime =
                        this.dateTimeList[this.end].time || this.dateTimeList[this.end - 1].time; // 处理结束时间
                    this.selectedTime = `${startTime} - ${endTime}=${this.rowIndex}`;
                } else {
                    let st = this.end;
                    let en = this.start;
                    this.start = st;
                    this.end = en;
                    let startTime = "";
                    if (this.start == 0) {
                        startTime = "07:00";
                    } else {
                        startTime = this.dateTimeList[this.start - 1].time;
                    }
                    const endTime =
                        this.dateTimeList[this.end].time || this.dateTimeList[this.end - 1].time; // 处理结束时间
                    this.selectedTime = `${startTime} - ${endTime}=${this.rowIndex}`;
                }
            }
        },

        handleDateChange(e) {
            this.activeIndexDay = e.day;
            this.updateDate(e.day);
        },
        updateDate(date) {
            if (dayjs(date).isBefore(dayjs())) {
                this.query.begin = date;
                this.getDayList(date);
            } else {
                this.query.begin = dayjs().format("YYYY-MM-DD");
                this.getDayList(date);
            }
        },
        getDayList(date) {
            let q = this.query;
            $utils.api
                .load(`/admin/system/meeting/calculateDateAndWeek`, q, "get")
                .then((res) => {
                    // console.log(res);
                    if (res.code == 200) {
                        this.dayList = res.data;
                        if (date) {
                            let itemWidth = 60;
                            this.dayList.forEach((item, index) => {
                                if (item.day == date) {
                                    // console.log((index - 1) * itemWidth);

                                    this.$refs.scorll_box.scrollTo((index - 1) * itemWidth, 0)
                                }
                            })
                        }
                    }
                })
        },
        onAddMeetingRoom() {
            this.$Modal.success({
                closable: true,
                width: "800px",
                height: "80px",
                okText: "取消",
                showOk: false,
                render: (h) => {
                    return (
                        <div>
                            <AddMeetingRoom
                                onOnCancel={() => {
                                    this.onCancel();
                                }}
                                action="add"
                            />
                        </div>
                    );
                },
            });
        },
        onAddMeeting() {
            this.$Modal.success({
                closable: true,
                width: "800px",
                height: "80px",
                okText: "取消",
                showOk: false,
                render: (h) => {
                    return (
                        <div>
                            <AddMeeting
                                onOnCancel={() => {
                                    this.onCancel();
                                }}
                                action="add"
                            />
                        </div>
                    );
                },
            });
        },
        onActiveItem(item, index) {
            this.activeIndexDay = item.day
            this.activeItem = item
            // this.getMeetingList()
        }
    },
};
</script>

<style scoped lang="less">
.schedule_meeting {
    width: 100%;

    .meeting_header {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .header_left_popover {
            text-align: center;
        }

        .header_left_btn {
            height: 50px;
            width: 70px;
            border-radius: 8px;
            font-size: 24px;
            background: #409eff;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
        }

        .header_right_warp {
            width: calc(100% - 80px);
            overflow-x: auto;

            .header_right {
                display: flex;
                align-items: center;

                .header_right_item {
                    flex: 0 0 60px;
                    text-align: center;
                    box-sizing: border-box;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    padding: 10px 0;
                    box-sizing: border-box;

                    .right_item_top {
                        margin-bottom: 8px;
                    }

                    .right_item_bottom {
                        padding: 3px 5px;
                        border-radius: 8px;
                        font-size: 12px;
                    }
                }

                .header_right_item_active {
                    background: #f1eded;
                }

                .right_item_bottom_active {
                    background: #0e90d2;
                    color: #fff;
                }
            }
        }
    }

    .meeting_main {
        overflow-x: scroll;
        width: 100%;
        display: flex;
        flex-direction: column;

        .meeting_main_theader {
            min-width: 2080px; // 根据需求设置最小宽度
            flex: 0 0 auto; // 不允许压缩，保持原始宽度
            display: flex;
            align-items: center;
            font-size: 16px;
            background-color: #409eff;
            color: #fff;
            height: 60px;
            box-sizing: border-box;

            .theader_boxhead {
                min-width: 120px;
                height: 60px;
                white-space: nowrap;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #fff;
                box-sizing: border-box;

                &:last-child {
                    border-right: none;
                }
            }

            .theader_boxhead_title {
                padding: 0 5px;
                flex: 0 0 280px;
                text-align: center;
                box-sizing: border-box;
                position: sticky;
                top: 0;
                left: 0;
                z-index: 10;
                background-color: #409EFF;
            }

        }

        .meeting_main_tmain_box {

            min-width: 2080px; // 根据需求设置最小宽度
            flex: 0 0 auto; // 不允许压缩，保持原始宽度
            display: flex;
            align-items: center;
            font-size: 16px;
            height: 50px;
            border: 1px solid #e1e1e1;
            border-left: none;
            border-top: none;
            position: relative;

            .theader_boxhead_title {
                height: 50px;
                // white-space: nowrap;
                display: flex;
                align-items: center;
                justify-content: start;
                padding: 0 10px;
                flex: 0 0 280px;
                text-align: center;
                box-sizing: border-box;
                color: #000;
                border-right: 1px solid #e1e1e1;
                position: sticky;
                /* 使元素粘性定位 */
                top: 0;
                left: 0;
                /* 在滚动时固定在顶部 */
                background-color: #fff;
                /* 背景颜色以确保可读性 */
                z-index: 10;
                border-left: 1px solid #e1e1e1;
                border-bottom: 1px solid #e1e1e1;
                /* 确保在其他元素之上 */

            }

            .theader_boxhead_item_box {
                background: #4197f3;
                color: #fff;
                height: 50px;
                line-height: 50px;
                text-align: center;
                z-index: 1;
            }

            .meeting_main_tmain {
                min-width: 1800px;
                flex: 1;
                display: flex;
                align-items: center;
                font-size: 16px;
                height: 50px;
                box-sizing: border-box;

                .theader_boxhead_item {
                    flex: 1;
                    height: 50px;
                    // border: 1px solid #e1e1e1;
                    border-bottom: none;
                    border-right: none;
                    box-sizing: border-box;
                    border-right: 1px solid #e1e1e1;

                    &:last-child {
                        border-right: none;
                    }
                }

                .disabledClass {
                    background-color: #e3e3e3;
                    border-bottom: 1px solid #fff;
                    border-right: 1px solid #fff;
                }

                .selected {
                    background-color: #4197f3;
                    /* 选中的单元格颜色 */
                    color: white;
                }

                .selected-time {
                    margin-top: 10px;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
